import { API_URL } from 'utils/constants/app';
import { RequestHelper } from 'utils/helpers/RequestHelper';

const productServiceUrl = `${API_URL}/product`;

const getProductsByNameAndNumber = (productSearchData, signal) =>
  RequestHelper.POST(`${productServiceUrl}/productsByNameAndNumber`, productSearchData, { signal });

export const ProductService = {
  getProductsByNameAndNumber
};